<template>
    <div class="image-container" :class="{ playing: isPlaying }">
        <div :class="{ 'bg-image': true }" :style="`background-image: url(${trackImage});`"></div>
        <svg ref="track-progress" class="track-progress">
            <circle cx="40" cy="40" r="37"></circle>
        </svg>
        <div class="track-button" v-if="isPlaying" @click="onPauseHandler(trackId)" title="Pause song">
            <i class="fa fa-pause-circle font-size-22"></i>
        </div>
        <div class="track-button" v-else @click="onPlayHandler(trackUrl, trackId)" title="Play song">
            <i class="fa fa-play-circle font-size-22"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'spotify-player',

    props: {
        trackImage: {
            type: String
        },
        trackId: {
            type: String
        },
        trackUrl: {
            type: String
        },
        trackPlaying: {
            default: null
        },
        audio: {
            default: null
        }
    },

    data() {
        return {
            isPlaying: false,
            currentTrack: null
        }
    },

    watch: {
        trackPlaying(val) {
            if (val !== this.currentTrack) {
                this.onPauseHandler()
            }
        }
    },

    mounted() {
        this.audio.addEventListener('pause', () => {
            this.onPauseHandler()
        })
    },

    methods: {
        onPlayHandler(url, id) {
            let r = 37
            let c = 2 * Math.PI * r
            let progressCircle = this.$refs['track-progress'].getElementsByTagName('circle')[0]
            let audio = this.audio

            progressCircle.style.strokeDasharray = c
            progressCircle.style.strokeDashoffset = c

            if (url === null) {
                alert(`This song doesn't have preview.`)
                return
            }

            audio.setAttribute('src', url)
            audio.play()
            this.isPlaying = true
            this.currentTrack = id

            this.$emit('playing', id)

            audio.addEventListener('timeupdate', () => {
                let timeplay = audio.currentTime / audio.duration
                let percent = c * (1 - timeplay)
                progressCircle.style.strokeDashoffset = percent
            })

            audio.onended = () => {
                this.isPlaying = false
                this.currentTrack = null
            }
        },

        onPauseHandler() {
            let audio = this.audio

            if (!isNaN(audio.duration)) {
                audio.pause()
            }
            this.isPlaying = false
            this.$emit('paused')
        }
    }
}
</script>

<style lang="scss" scoped>
.image-container {
    width: 5rem;
    height: 5rem;
    position: relative;

    .bg-image {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        border: 1px solid #eaeaea;
    }

    .track-progress {
        position: absolute;
        top: 0;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: rotate(-90deg) translate(0, -50%);
        transform-origin: center;
        opacity: 0;
        z-index: 1;

        circle {
            fill: transparent;
            stroke: var(--icon-color);
            stroke-width: 5;
        }
    }

    .track-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    &.playing {
        .bg-image {
            transition: 0.3s;
            border-radius: 50%;
            animation: playing 1s linear infinite;

            @keyframes playing {
                0% {
                    transform: rotate(0);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }

        .track-progress {
            opacity: 1;
        }

        .track-button {
            border-radius: 50%;
        }
    }
}
</style>
